import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '../utils/constants';

const useSearch = () => {
  const navigate = useNavigate();

  const redirectToSearchPage = (key?: string | null, page?: number) => {
    if (!key?.trim()) return;

    navigate(`${AppRoutes.search}?key=${encodeURIComponent(key?.trim())}&page=${page || 1}`);
  };

  return { redirectToSearchPage };
};

export default useSearch;
